"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigModule = exports.sanitizeConfig = exports.sanitizeDomain = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var set_1 = tslib_1.__importDefault(require("lodash/set"));
/**
 * Config module holds SDK configuration variables
 *
 * Currently its only custom domain - which enabled using
 * sdk from different domain (using CORS)
 *
 * Never set properties directly - always use setter methods
 *
 */
var URL_REGEXP = "(?:(https)://+|(www\\.)?)\\w[:;,\\.?\\[\\]\\w/~%&=+#-@!]*";
function sanitizeDomain(domain) {
    if (domain === null) {
        return undefined;
    }
    var sanitizedDomain = domain || "";
    var link = sanitizedDomain.match(URL_REGEXP);
    if (!link) {
        throw new Error(domain + " is not a valid url");
    }
    // ensure https:// prefix and strip possible trailing /
    return "https://" + link[0].replace(/^https?:\/\/|\/$/g, "");
}
exports.sanitizeDomain = sanitizeDomain;
/**
 * Returns sanitized config
 *
 * @returns config with sanitized domain
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function sanitizeConfig(config) {
    var sanitized = tslib_1.__assign({}, config);
    if (config.domain) {
        sanitized.domain = sanitizeDomain(config.domain);
    }
    return sanitized;
}
exports.sanitizeConfig = sanitizeConfig;
/**
 * Config factory
 *
 * @param configStorage - config object
 * @returns SDK config module
 */
var ConfigModule = /** @class */ (function () {
    function ConfigModule(configStorage) {
        this.configStorage = configStorage;
        if (arguments.length !== 1) {
            throw new Error("Config module has to be called with exactly one argument.");
        }
    }
    /**
     * Sets custom domain. Parameter is url which has always to be https://
     * (if you don't provide it, we will do it for you).
     *
     * RegExp inspired taken from
     * https://github.com/jarib/google-closure-library/blob/master/closure/goog/string/linkify.js
     * @param domain - valid domain starting with https:// or null for removing
     */
    ConfigModule.prototype.setCustomDomain = function (domain) {
        this.configStorage.domain = sanitizeDomain(domain);
    };
    /**
     * Returns current domain
     *
     */
    ConfigModule.prototype.getCustomDomain = function () {
        return this.configStorage.domain;
    };
    /**
     * Sets JS package and version info
     *
     * @param name - package name
     * @param version - package version (semver)
     * @internal
     */
    ConfigModule.prototype.setJsPackage = function (name, version) {
        if (!this.configStorage.originPackage) {
            // only set the first (topmost) package
            this.configStorage.originPackage = { name: name, version: version };
        }
    };
    /**
     * Returns JS package and version info
     *
     * @returns with 'name' and 'version' properties
     * @internal
     */
    ConfigModule.prototype.getJsPackage = function () {
        return this.configStorage.originPackage;
    };
    ConfigModule.prototype.setRequestHeader = function (key, value) {
        set_1.default(this.configStorage, ["xhrSettings", "headers", key], value);
    };
    ConfigModule.prototype.getRequestHeader = function (key) {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.configStorage) === null || _a === void 0 ? void 0 : _a.xhrSettings) === null || _b === void 0 ? void 0 : _b.headers) === null || _c === void 0 ? void 0 : _c[key];
    };
    return ConfigModule;
}());
exports.ConfigModule = ConfigModule;
//# sourceMappingURL=config.js.map